export const renderDownload = (download) => {
  const gridContainer = document.createElement("div");
  gridContainer.classList.add("col-xs-12", "col-sm-6", "col-md-4");
  const root = document.createElement("div");
  root.classList.add("tile");
  const teaserImage = document.createElement("img");
  teaserImage.classList.add("tile__bgimage");
  teaserImage.classList.add("tile__width");
  teaserImage.src = download.teaserImageUri;
  teaserImage.alt = "";
  teaserImage.loading = "lazy";
  const tileText = document.createElement("div");
  tileText.classList.add("tile__text");
  const headline = document.createElement("div");
  headline.classList.add("headline", "headline--3", "color--magenta");
  headline.innerHTML = download.title;
  tileText.append(headline);
  if (download.copyright) {
    const copyright = document.createElement("p");
    copyright.classList.add("font--highlighted");
    copyright.innerHTML = download.copyright;
    tileText.append(copyright);
  }
  for (const file of download.files) {
    const fileRoot = document.createElement("a");
    fileRoot.classList.add("text-with-icon", "text-with-icon--down");
    fileRoot.href = `${file.publicUrl}`;
    fileRoot.download = download.title;
    fileRoot.append(document.createTextNode(file.downloadLinkLabel));
    tileText.append(fileRoot);
  }
  root.append(teaserImage, tileText);
  gridContainer.append(root);
  return gridContainer;
};
